import { render, staticRenderFns } from "./Fishcatchcategorysummary.vue?vue&type=template&id=6260e6b2&"
import script from "./Fishcatchcategorysummary.vue?vue&type=script&lang=js&"
export * from "./Fishcatchcategorysummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports